export { bankDocumentTemplatesRoute } from './route'
